export const k3k3k3sanbutonghao = {
	balls:[
	   [-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
	 -1,-1,-1,-1,-1,-1,-1,-1,-1,-1]
	],
    num: [
	   [123,134,146,236,345,
	 124,135,156,245,346,
	 125,136,234,246,356,
	 126,145,235,256,456]
    ],
    views: [
	   [123,134,146,236,345,
	 124,135,156,245,346,
	 125,136,234,246,356,
	 126,145,235,256,456]
    ],
    titles: [
	  '三不同号'
    ],
    getLottery:(num,balls)=>{
        let view = ""; 
        for(let i = 0;i < balls.length;i++){
		    for(let l = 0;l < balls[i].length;l++){
			    if(i == 0){
			    	if(balls[i][l] > 0){
					    view +=num[i][l]+"|"
				    }
			    }
		    }
    	}
	    return view.substring(0,view.length-1);
    },
    getNum:(balls)=>{
        let num = 0,arr = balls[0];
        for(let i=0,len=arr.length;i<len;i++){
            if(arr[i]>0){
                num++;
            }
        }
        return num;
    },
    getView: (views,balls)=>{
        let view = ""; 
        for(let i = 0;i < balls.length;i++){
		    for(let l = 0;l < balls[i].length;l++){
			    if(i == 0){
			    	if(balls[i][l] > 0){
					    view +=views[i][l]+"|"
				    }
			    }
		    }
    	}
	    return view.substring(0,view.length-1);
    }
}
